import React from "react";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import ClientProfile from "../components/clientProfile/clientProfile.js";
import {
  setClientProfile,
  SET_CLIENT_PROFILE_IN_PROGRESS,
  SET_CLIENT_PROFILE_SUCCESS
} from "../actions/clientProfile.action";
import { ROUTE_CLIENT_PROFILE } from "./RouteConstants";
import { setProfilePic } from "../actions/personalProfile.actions";

class ClientProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "new"
    };
  }

  saveProfieImg = event => {
    if (event.target.files[0]) {
      let file = event.target.files[0];
      let formData = new FormData();
      let data = {};
      formData.append("file", event.target.files[0]);
      data["formData"] = formData;
      data["file"] = file;
      this.props.setProfilePic(data);
    }
  };

  render() {
    const isSaveInProgress =
      this.props.setProfileState === SET_CLIENT_PROFILE_IN_PROGRESS;

    if (this.props.setProfileState === SET_CLIENT_PROFILE_SUCCESS) {
      return <Redirect to={`/next-step${ROUTE_CLIENT_PROFILE}`} />;
    }

    return (
      <div>
        <ClientProfile
          mode={this.state.mode}
          setClientProfile={this.props.setClientProfile}
          setProfileState={this.props.setProfileState}
          isSaveInProgress={isSaveInProgress}
          saveProfileImg={this.saveProfieImg}
          profile={this.props.profile}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  setProfileState: state.ClientProfile.setProfileState,
  profile: state.personalProfile.profile
});

const mapDispatchToProps = dispatch => ({
  setClientProfile: data => dispatch(setClientProfile(data)),
  setProfilePic: data => dispatch(setProfilePic(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientProfilePage)
);
